<template>
  <b-container id="proj" class="pb-2" fluid>
    <h3>
      <b-row no-gutters align-v="center">
        <b-col cols="1" @click="onShow" v-b-toggle.collapse-2>
          <font-awesome-icon icon="thumbtack" class="fa-rotate-270" size="xs" v-if="show"/>
          <font-awesome-icon icon="thumbtack" size="xs" v-else/>
        </b-col>
        <b-col class="pt-1" cols="5">
          <span>
            Projects
          </span>
        </b-col>
        <b-col class="pt-1 pl-2" cols="3">
            <b-button class="ml-4" size="sm" id="button_show" v-b-toggle.collapse-2 variant="light" @click="onShow">{{ showText }}</b-button>
        </b-col>
      </b-row>
    </h3>
    <span class="pl-4 text-variant-light">Sampling of projects that I have worked on.</span>
    <b-collapse id="collapse-2" class="mt-2" visible>
      <b-card-group deck class="justify-content-center">
        <ProjectCard v-for="i in 3" :key="i" :link="projects[indices[i - 1]].link" :title="projects[indices[i - 1]].title" :file="projects[indices[i - 1]].file" :about="projects[indices[i - 1]].about"/>
      </b-card-group>
      <b-card-group deck class="justify-content-center">
        <ProjectCard v-for="i in 3" :key="i" :link="projects[indices[i + 2]].link" :title="projects[indices[i + 2]].title" :file="projects[indices[i + 2]].file" :about="projects[indices[i + 2]].about"/>
      </b-card-group>
      <b-card-group deck class="justify-content-center">
        <ProjectCard v-for="i in 3" :key="i" :link="projects[indices[i + 5]].link" :title="projects[indices[i + 5]].title" :file="projects[indices[i + 5]].file" :about="projects[indices[i + 5]].about"/>
      </b-card-group>
      <b-card-group deck class="justify-content-center">
        <ProjectCard v-for="i in 2" :key="i" :link="projects[indices[i + 8]].link" :title="projects[indices[i + 8]].title" :file="projects[indices[i + 8]].file" :about="projects[indices[i + 8]].about"/>
      </b-card-group>
    </b-collapse>
  </b-container>
</template>
<script>
import ProjectCard from '@/components/subcomponents/ProjectCard'
import projects from '@/assets/projects.json'
export default {
  components: {
    ProjectCard
  },
  data () {
    return {
      showText: 'Hide',
      show: true,
      projects: projects
    }
  },
  computed: {
    indices () {
      return Object.keys(this.projects)
    }
  },
  methods: {
    onShow () {
      if (this.show) {
        this.showText = 'Show'
      } else {
        this.showText = 'Hide'
      }
      this.show = !this.show
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  }

}
</script>

<style>
#about {
}

.head {
  padding-left: 10px;
}
.icons {
  display: flex;
}
</style>
